import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import SocialSharing from 'vue-social-sharing'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'

import '@/assets/sass/main.sass'

Vue.use(VueCookies)

Vue.use(VueI18n)

const messages = {
  en: {
    message: {
      viewmap: 'Open with Google Maps',
      eventclassdetail: 'Recommended events and videos',
      event: 'Event',
      video: 'Video',
      allevents: '',
      viewmore: 'View more',
      videdetail: 'All haircut techniques videos',
      accessoriessearch: 'Find the accessories you need',
      findaccessories: 'Find the accessories',
      search: 'Search',
      categories: 'Categories',
      all: 'All',
      noproduct: 'No product found!',
      buy: 'Buy',
      overview: 'Overview',
      productdetail: 'Product detail',
      warranty: 'Warranty',
      searchplaceholder: 'Lookup for product, events or videos',
      searchresult: 'SEARCH RESULTS FOR &#34;{keyword}&#34;',
      searchcount: 'Total about {count} results.',
      relatedvideos: 'Related videos',
      blogsubtitle: 'Recommended articles',
      by: 'By',
      popularposts: 'Popular articles',
      relatedarticles: 'Related articles',
      fromshop: 'From',
      youmaylike: 'you may also like',
      storelocator: 'Store locator',
      storename: 'Store name',
      phonenumber: 'Phone number',
      address: 'Address',
      direction: 'Direction',
      detail: 'Detail',
      allstores: 'All stores',
      barbername: 'Barber name',
      storeresults: '{total} stores',
      province: 'Province',
      allprovinces: 'All provinces',
      storeexample: 'e.g. Barber',
      consentmessage: `We use cookies on our website to give you the most relevant experience by remembering your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies. However you may visit Cookie settings to provide a controlled consent.`,
      accept: 'Accept',
      cookiesetting: 'Cookie settings'
    }
  },
  th: {
    message: {
      viewmap: 'เปิดด้วย Google Maps',
      eventclassdetail: 'กิจกรรม และวิดีโอที่แนะนำ',
      event: 'กิจกรรม',
      video: 'วิดีโอ',
      allevents: 'กิจกรรมทั้งหมด',
      viewmore: 'ดูเพิ่มเติม',
      videdetail: 'รวมวิดีโอเทคนิคการตัดผมทั้งหมด',
      accessoriessearch: 'ค้นหาอุปกรณ์เสริมที่คุณต้องการ',
      findaccessories: 'ค้นหาอุปกรณ์เสริม',
      search: 'ค้นหา',
      categories: 'หมวดหมู่',
      all: 'ทั้งหมด',
      noproduct: 'ไม่พบสินค้า',
      buy: 'สนใจสั่งซื้อ',
      overview: 'ภาพรวม',
      productdetail: 'ข้อมูลผลิตภัณฑ์',
      warranty: 'การรับประกันสินค้า',
      searchplaceholder: 'ค้นหาสินค้า กิจกรรม หรือวิดีโอ',
      searchresult: 'ผลการค้นหาคำว่า &#34;{keyword}&#34;',
      searchcount: 'ผลลัพธ์ {count} รายการ',
      relatedvideos: 'วิดีโอเทคนิคการตัดผมที่คุณอาจสนใจ',
      blogsubtitle: 'บทความแนะนำ',
      by: 'โดย',
      popularposts: 'บทความยอดนิยม',
      relatedarticles: 'บทความที่เกี่ยวข้อง',
      fromshop: 'จากร้าน',
      youmaylike: 'ที่คุณอาจสนใจ',
      storelocator: 'ค้นหาที่ตั้งร้าน',
      storename: 'ชื่อร้าน',
      phonenumber: 'เบอร์โทรศัพท์',
      address: 'ที่อยู่',
      direction: 'เส้นทาง',
      detail: 'รายละเอียด',
      allstores: 'รายชื่อร้านค้าทั้งหมด',
      barbername: 'ช่างประจำ',
      storeresults: 'ผลการค้นหา {total} ร้าน',
      province: 'จังหวัด',
      allprovinces: 'ทุกจังหวัด',
      storeexample: 'เช่น Barber',
      consentmessage: `เราใช้คุกกี้บนเว็บไซต์ของเราเพื่อให้คุณได้รับประสบการณ์ที่ดีที่สุดโดยจดจำความชอบของคุณและเข้าชมซ้ำ โดยการคลิก "ยอมรับ" แสดงว่าคุณยินยอมให้ใช้คุกกี้ทั้งหมด อย่างไรก็ตาม คุณสามารถไปที่การตั้งค่าคุกกี้เพื่อให้คำยินยอมการใช้งานคุกกี้`,
      accept: 'ยอมรับ',
      cookiesetting: 'ตั้งค่าคุกกี้'
    }
  }
}

let currentLang = VueCookies.get('pll_language')
if (!currentLang) {
  currentLang = 'en'
}

const i18n = new VueI18n({
  locale: currentLang, // set locale
  messages // set locale messages
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attemp: 1,
  listenEvents: ['scroll'],
  lazyComponent: true
})

Vue.use(SocialSharing)

Vue.use(VueYouTubeEmbed)

Vue.use(VueScrollTo, {
  offset: -148
})

Vue.component('accordion', require('./components/Accordion.vue').default)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
